import Dollar from "assets/icons/Dollar";
import Euro from "assets/icons/Euro";
import GBPIcon from "assets/icons/GBPIcon";
import { countries, nationalities } from "data/ISO3166";
import { companyDetailsRole } from "data/options";
import {
  format,
  subDays,
  subMonths,
  lastDayOfMonth,
  isEqual,
  startOfMonth,
  parseISO,
} from "date-fns";

export const filterObject = (obj, condition) =>
  Object.fromEntries(Object.entries(obj).filter(condition));

export function formatSwitchStringToBoolean(value) {
  if (value === "N") return false;
  else if (value === "Y") return true;
}

export function convertImageToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = () => {
      resolve(reader.result.split("base64,")[1]);
    };
    reader.onerror = (error) => {
      reject(error);
    };
  });
}

/**
 * @param amount string
 * @param currency string
 *
 * @description expected value for parameter is either +1.0 or -1.0
 * expected return value is €1.0 or €-1.0
 *
 * @returns string
 */
export function formatAmountTableValue(amount = "", currency = "") {
  if (!amount || !currency) return Number.parseFloat("0").toFixed(2);
  return `${Number(amount) > 0 ? " " : " "}${Math.abs(
    Number.parseFloat(amount)
  ).toFixed(2)}`;
  // if (!amount || !currency) return;
  // // if (!amount.split(".")[1]) return

  // // if the amount is a whole number, for example, "+10"
  // if (!amount.split(".")[1]) {
  //   if (amount > 0) {
  //     return `${getCurrency(currency)}${amount.slice(1)}`;
  //   } else {
  //     return `${amount.slice(0, 1)}${getCurrency(currency)} ${amount.slice(1)}`;
  //   }
  // }

  // // is the amount is a decimal number, for example, "-0.5"
  // if (amount > 0) {
  //   if (amount.split(".")[1].length > 1) {
  //     return `${getCurrency(currency)}${amount.slice(1)}kkk`;
  //   } else {
  //     return `${getCurrency(currency)}${amount.slice(1)}0`;
  //   }
  // } else {
  //   if (amount.split(".")[1].length > 1) {
  //     return `${amount.slice(0, 1)}${getCurrency(currency)}${amount.slice(1)}`;
  //   } else {
  //     return `${amount.slice(0, 1)}${getCurrency(currency)}${amount.slice(1)}0`;
  //   }
  // }
}
// get the city, state, and postal
export async function getCityStatePostal() {
  const location = await window.navigator.geolocation.getCurrentPosition(
    (position) => {
      const { latitude, longitude } = position.coords;
      fetch(
        `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${latitude}&longitude=${longitude}&localityLanguage=en`
      )
        .then((response) => response.json())
        .then((data) => {
          console.log(data);
        });
    }
  );
  return {
    city: location.city,
    state: location.state,
    postal: location.postal,
  };
}

export function getCurrency(currency = "") {
  return currency === "EUR"
    ? "€"
    : currency === "USD"
    ? "$"
    : currency === "GBP"
    ? "£"
    : null;
}

export function formatDateTableValue(date = "") {
  return date.split("-").reverse().join("/");
}

export function formatDate(date) {
  const _date = new Date(date);
  const year = _date.getFullYear();
  const month = String(_date.getMonth() + 1).padStart(2, "0");
  const day = String(_date.getDate()).padStart(2, "0");

  return [year, month, day].join("-");
}

//dd.mm.yyyy
export function formatDateFormat2(date) {
  const _date = new Date(date);
  const year = _date.getFullYear();
  const month = String(_date.getMonth() + 1).padStart(2, "0");
  const day = String(_date.getDate()).padStart(2, "0");

  return [day, month, year].join(".");
}

//convert date to dd/mm/yyyy, hr:mm:ss
export function convertDate(timestamp, showTime = true) {
  let currentTimestamp = new Date(parseInt(timestamp));

  if (showTime === true) {
    return new Intl.DateTimeFormat("en-UK", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    }).format(timestamp);
  } else {
    return new Intl.DateTimeFormat("en-UK", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).format(timestamp);
  }
}
//convert date to dd Month yyy i.e 21 November 2023
export function convertDateToName(timestamp) {
  let currentTimestamp = new Date(parseInt(timestamp));

  return new Intl.DateTimeFormat("en-UK", {
    year: "numeric",
    month: "long",
    day: "2-digit",
  }).format(timestamp);
}
// convert 2024-03-25 08:42:55 to dd.MM.YYYY
export const formatDateToDDMMYYYY = (date) => {
  if (date) {
    var parts = date.split(" ");
    var day =
      parts[0].length === 3 ? "0" + parts[0].charAt(0) : parts[0].slice(0, 2);
    var month = parts[1];
    var year = parts[2];
    var months = {
      January: "01",
      February: "02",
      March: "03",
      April: "04",
      May: "05",
      June: "06",
      July: "07",
      August: "08",
      September: "09",
      October: "10",
      November: "11",
      December: "12",
    };
    month = months[month];
    return day + "." + month + "." + year;
  }
  return;
};
// convert 1974-07-04 to 04.07.1974
export const formatDateToDDMMYYYY2 = (date) => {
  if (date) {
    var parts = date.split("-");
    var day = parts[2];
    var month = parts[1];
    var year = parts[0];
    return day + "." + month + "." + year;
  }
  return;
};
// customize amount to have a space if its a negative and must have 2 decimal places
export const customizeAmount = (amount) => {
  if (!amount) return Number.parseFloat("0").toFixed(2);
  return `${Math.abs(Number.parseFloat(amount)).toFixed(2)}`;
};

// convert 16th October 2023 to dd.MM.YYYY

// 2024-04-02 09:56:31 to 9:56 (24 hour format)
export const formatTime = (time) => {
  if (!time) return;
  const parts = time.split(" ");
  const timeParts = parts[1].split(":");
  return `${timeParts[0]}:${timeParts[1]}`;
};
export const setCurrencyColor = (currency, amount, size = 16) => {
  if (!currency) return;
  const isPositiveAmount = amount >= 0;
  const redColor = "#FF7171";
  const greenColor = "#0DCA9D";
  const pendingColor = "#FBB445";

  if (currency === "EUR") {
    return (
      <Euro size={size} color={isPositiveAmount ? greenColor : redColor} />
    );
  }
  if (currency === "USD") {
    return (
      <Dollar size={size} color={isPositiveAmount ? greenColor : redColor} />
    );
  }
  if (currency === "GBP") {
    return (
      <GBPIcon size={size} color={isPositiveAmount ? greenColor : redColor} />
    );
  }
};

export function getCurrentDate() {
  const date = new Date();
  return `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`;
}

export const getDate90DaysAgo = () => {
  const date = new Date();
  // date.setDate(date.getDate() - 60);
  // const month = date.getMonth() < 10 ? `0${date.getMonth()}` : date.getMonth();
  // let day = "";
  // if ((date.getDate() + 1) < 10) {
  //   day = `0${date.getDate() + 1}`;
  // } else {
  //   // if the month is February and the year is a leap year, set the day to 29
  //   day = date.getMonth() === 2 && date.getFullYear() % 4 === 0 ? 29 : (date.getDate() + 1);
  // }
  const pastDate = subDays(date, 90);
  const formattedPastDate = format(pastDate, "yyyy-MM-dd");
  return formattedPastDate;
};

export const getDateSixMonthsAgo = () => {
  const date = new Date();
  date.setMonth(date.getMonth() - 5);
  // if month is 1 digit, add 0 before it
  const month = date.getMonth() < 10 ? `0${date.getMonth()}` : date.getMonth();
  const day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
  return `${date.getFullYear()}-${month}-${day}`;
};

export function calculateFirstDateOfCurrentMonth() {
  const date = new Date();
  date.setDate(1); // get the first date of the current month
  return `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`;
}

export function scrollToTopOfPage() {
  window.document.body.scrollTop = 0;
  window.document.documentElement.scrollTop = 0;
}

export const arrayChecker = (arr) => {
  return arr && Array.isArray(arr) && arr.length > 0 ? true : false;
};

// set object value for countryOfBirth and nationality in sync with initialValues and form value
export const countryValueFromLocalStorage = (type, value) => {
  const selectedDataCountryOfBirth = {};
  if (value) {
    const arrCountry = type === "country" ? countries : nationalities;
    const countryObj = arrCountry.find((country) => country.alpha3 === value);
    if (countryObj && Object.keys(countryObj).length > 0) {
      Object.assign(selectedDataCountryOfBirth, {
        label: type === "country" ? countryObj?.name : countryObj?.nationality,
        value: countryObj?.alpha3,
      });
    }
  }
  return Object.keys(selectedDataCountryOfBirth).length > 0
    ? selectedDataCountryOfBirth
    : null;
};

export const countriesValueFromLocalStorage = (value) => {
  let selectedCountries = [];
  if (arrayChecker(value)) {
    selectedCountries = countries.filter((country) =>
      value.includes(country?.alpha3)
    );
  }
  return selectedCountries.length > 0 ? selectedCountries : null;
};

export const commaSeparator = (index, arr) => {
  if (!arrayChecker(arr)) return "";
  return index + 1 === arr.length ? "" : ", ";
};

export const firstCharIsMinus = (value) => {
  if (!value) return "-";
  const amount = value ? value : "";
  const firstAmountChar = amount ? amount.charAt(0) : null;
  const charIsMinus = firstAmountChar === "-";
  return charIsMinus;
};

export const formatCurrencyToLocalEn = (currency) => {
  const trimString = currency.replace(/[^0-9.-]+/g, "");
  if (trimString) {
    return parseFloat(trimString).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }
  return 0.0;
};

export const formatCurrency = (value, currency) => {
  const hasMinus = firstCharIsMinus(value);
  if (hasMinus && value) {
    const removedFirstChar = value.slice(1);
    return `-${getCurrency(currency)}${formatCurrencyToLocalEn(
      removedFirstChar
    )}`;
  } else if (!hasMinus && value) {
    return `${getCurrency(currency)}${formatCurrencyToLocalEn(value)}`;
  }
  return `${getCurrency(currency)}0.00`;
};

export function getCurrencySymbol(curreny) {
  //get currency symbol
  switch (curreny) {
    case "EUR":
      return "<p>&#8364;</p>";
    case "USD":
      return "&#36";
    case "GBP":
      return "&#163";
    case "YEN":
      return "&#165";
    default:
      return "&#8364";
  }
}

export const truncateText = (value) => {
  /*
    -will check a word or upt to 3 words then truncate
     -if 3 words
      -truncate the first 4 letter of word then show only the first letter of second and thirs word ie "clos..B = Closing Balance"
    -if 1 word
     -if word is less than 7 char dont truncate else truncate ie "ClosingBalance = Closing.."
  */
  const text = value.split(" ") || [];
  if (text.length > 1) {
    const [firstWord, secondWord, thirdWord] = text;
    return `${firstWord.substring(0, 4)}...${secondWord.substring(0, 1)}${
      thirdWord ? `..${thirdWord.substring(0, 1)}` : ""
    }`;
  }
  return text.length > 0 && text[0].length > 7
    ? `${text[0].substring(0, 6)}...`
    : text[0];
};

export function getPendingAmount(avlbal, currentBalance) {
  if (!avlbal || !currentBalance) {
    return 0.0;
  }
  const pendingAmount = Math.abs(Number(currentBalance) - Number(avlbal));
  //use toFixed(2) to format nuber to 2 decimal places
  return pendingAmount.toFixed(2);
}

const chechIfResponseIsError = (response) => {
  const errorCodes = [
    500,
    400,
    401,
    403,
    404,
    405,
    406,
    409,
    422,
    429,
    "500",
    "400",
    "401",
    "403",
    "404",
    "405",
    "406",
    "409",
    "422",
    "429",
  ];
  if (
    response &&
    (errorCodes.includes(response.status) || errorCodes.includes(response.code))
  ) {
    return true;
  }
  return false;
};

export const getUserActiveCards = (cards) => {
  if (!cards || chechIfResponseIsError(cards)) return [];
  const activeCards = cards.filter((card) => card.lostYN === "N");
  return cards.filter((card) => card.lostYN === "N");
};

export const catchErrorMessage = (error) => {
  const errorMessage = {
    code: 400,
    message: "Exception error. Please try again",
    status: "Failed",
    data: null,
  };
  if (error) {
    const errObject = JSON.parse(error);
    Object.assign(errorMessage, { ...errObject });
  }
  return errorMessage;
};

export const checkStringIfContainsNumbers = (value) => {
  return /^\d+$/.test(value);
};

export function formatDateDot(date) {
  const _date = new Date(date);
  const year = _date.getFullYear();
  const month = String(_date.getMonth() + 1).padStart(2, "0");
  const day = String(_date.getDate()).padStart(2, "0");

  return [day, month, year].join(".");
}

export const formatDateTime = (date) => {
  if (date) {
    const parts = date.split(" ");
    const dateParts = parts[0].split("-");
    return `${dateParts[2]}.${dateParts[1]}.${dateParts[0]}`;
  }
  return;
};

export const formatTransactionsForPaymentScreen = (transactions) => {
  if (!transactions) return [];
  return transactions
    .filter((transaction) => transaction.service !== "DEBIT CARD")
    .map((transaction) => ({
      ...transaction,
      // amount: formatAmountTableValue(transaction.amount, transaction.currency),
      amount: transaction.amount,
      date: formatDateTableValue(transaction.transaction_datetime.toString()),
    }));
};

export const getNameInitials = (name) => {
  if (!name) return "";
  const arrName = name.split(" ");
  // to upppercase
  const firstName = arrName.shift();
  const lastName = arrName.join(" ");
  return `${firstName.charAt(0).toUpperCase() || ""}${lastName.charAt(0).toUpperCase() || ""}`;
};
// when the name is more than 15 characters replace with ...
export const stringShortener = (name, length = 19) => {
  if (!name) return "";
  return name.length > length ? `${name.substring(0, length)}...` : name;
};

export const displayItemName = (transaction) => {
  if (!transaction) return "";
  if (transaction.transaction_direction === "outgoing") {
    return transaction?.name || transaction?.purpose;
  } else {
    return transaction?.debtor_name || transaction?.purpose;
  }
};

export const formatNumberValue = (value) => {
  if (!value) return 0;
  return Math.abs(value);
};
export const naturalPersonKeys = [
  "naturalPersonDetailsTitle",
  "naturalPersonDetailsName",
  "naturalPersonDetailsSurname",
  "naturalPersonDetailsSex",
  "naturalPersonDetailsNationality",
  "naturalPersonDetailsDateOfBirth",
  "naturalPersonDetailsPlaceOfBirth",
  "naturalPersonDetailsEmailAddress",
  "naturalPersonDetailsCountryCode",
  "naturalPersonDetailsMobile",
  "naturalPersonDetailsDocumentType",
  "naturalPersonDetailsDocumentNumber",
  "naturalPersonDetailsDocumentCountryOfIssue",
  "naturalPersonDetailsDocumentDocumentExpiryDate",
  "naturalPersonDetailsAddressLine1",
  "naturalPersonDetailsAddressLine2",
  "naturalPersonDetailsCity",
  "naturalPersonDetailsPostalCode",
  "naturalPersonDetailsDocumentDateOfExpiry",
  "naturalPersonDetailsOccupation",
  "naturalPersonDetailsEmployment",
  "naturalPersonDetailsEmploymentPosition",
  "naturalPersonDetailsSourceOfIncome",
  "naturalPersonDetailsSourceOfWealth",
  "naturalPersonDetailsSourceOfWealthDetails",
  "naturalPersonDetailsOtherSourceOfIncome",
  "naturalPersonDetailsOtherSourceOfIncomeDetails",
  "naturalPersonDetailsTINID",
  "naturalPersonDetailsTaxCountry",
  "naturalPersonDetailsUSCitizen"
];

export const nonNaturalPersonKeys = [
  "nonNaturalPersonDetailsName",
  "nonNaturalPersonDetailsSurname",
  "nonNaturalPersonDetailsRegistrationNumber",
  "nonNaturalPersonDetailsDateOfIncorporation",
  "nonNaturalPersonDetailsTaxCountry",
  "nonNaturalPersonDetailsCountryOfIncorporation",
  "nonNaturalPersonDetailsAddressLine1",
  "nonNaturalPersonDetailsAddressLine2",
  "nonNaturalPersonDetailsCity",
  "nonNaturalPersonDetailsPostalCode",
  "nonNaturalPersonDetailsCountry",
  "nonNaturalPersonDetailsLocality",
  "nonNaturalPersonDetailsNationality",
  "nonNaturalPersonDetailsNameOfShareholderPercentHeld"
];

export const getLimitLabel = (limit) => {
  if (!limit) return "";
  if (limit === "transaction") return "Transaction Limits"; // correct
  if (limit === "atm_transaction") return "ATM Transaction Limits"; // correct
  if (limit === "pos_transaction") return "POS Transactions Limits";
  if (limit === "amount") return "Amount Limits"; // correct
  if (limit === "atm_amount") return "ATM Amount Limits"; // correct
  if (limit === "pos_amount") return "POS Amount Limits";
};

export const limitKeys = [
  "transaction",
  "atm_transaction",
  "pos_transaction",
  "amount",
  "atm_amount",
  "pos_amount",
];

export const copyToClipboard = (holder) => {
  const tempInput = document.createElement("input");
  tempInput.value = holder;
  document.body.appendChild(tempInput);
  tempInput.select();
  document.execCommand("copy");
  document.body.removeChild(tempInput);
};

export const dateFunctions = () => {
  const today = new Date();
  // Get the first day of the current month as a Date object
  const firstDayOfMonth = startOfMonth(today);

  // Subtract one month from the first day of the current month
  const previousMonthDate = subMonths(firstDayOfMonth, 1);

  // Get the last day of the previous month as a Date object
  const lastDateOfPrevMonthDate = lastDayOfMonth(previousMonthDate);

  // Format the dates for display
  const previousMonth = format(previousMonthDate, "LLLL");
  const firstDateOfMonth = format(firstDayOfMonth, "yyyy-MM-dd");
  const previousMonthCompleteDate = format(previousMonthDate, "yyyy-MM-dd");
  const lastDateOfPrevMonth = format(lastDateOfPrevMonthDate, "yyyy-MM-dd");
  const currentDay = format(today, "yyyy-MM-dd");
  const previousMonthFirstDay = format(
    subMonths(firstDayOfMonth, 1),
    "yyyy-MM-dd"
  );
  //const dateIsEqual = isEqual(firstDayOfMonth, currentDay);
  const currentYear = format(today, "yyyy");

  return {
    //dateIsEqual,
    currentDay,
    firstDateOfMonth,
    previousMonth,
    currentYear,
    previousMonthCompleteDate,
    previousMonthFirstDay,
    lastDateOfPrevMonth,
  };
};
export const dateFunctionsWithParams = ({ dateParamPrevMonth }) => {
  if (!dateParamPrevMonth) return null;
  const dateParam = new Date(dateParamPrevMonth);
  // Get the first day of the current month as a Date object
  const firstDayOfMonth = startOfMonth(dateParam);

  // Subtract one month from the first day of the current month
  const previousMonthDate = subMonths(firstDayOfMonth, 1);

  // Get the last day of the previous month as a Date object
  const lastDateOfPrevMonthDate = lastDayOfMonth(previousMonthDate);

  const previousMonthCompleteDate = format(previousMonthDate, "yyyy-MM-dd");

  const lastDateOfPrevMonth = format(lastDateOfPrevMonthDate, "yyyy-MM-dd");

  return { previousMonthCompleteDate, lastDateOfPrevMonth };
};

export const appRoutes = {
  registerPersonal: "/register/personal",
  signin: "/login",
  /* registerBusiness: "/register/business", */
  registerBusiness: "/register/business/v2",
  registerBusinessV2: "/register/business/v2",
  registrationStatus: "/registration/status",
  dashboard: "/dashboard",
  transactions: "/dashboard/transactions",
  card: "/dashboard/card",
  payments: "/dashboard/payments",
  statements: "/dashboard/statements",
  payees: "/dashboard/payees",
  profile: "/dashboard/profile",
  changePassword: "/change-password/:resetToken",
  expiredPassword: "/change-password",
  forgottenPassword: "/forgottenpassword",
  test: "/components",
};
